module.exports = __webpack_public_path__ + "assets/img/202108-6.56c0b846.png";